/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { FollowupTypes, FollowupState } from './types';

const INITIAL_STATE: FollowupState = {
  followups: { followup_list: [], total_entries: 0 },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<FollowupState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case FollowupTypes.GET_FOLLOWUPS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case FollowupTypes.GET_FOLLOWUPS_SUCCESS:
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        draft.followups.followup_list = result.data.followups;
        draft.followups.total_entries = result.data.total_entries;
        break;

      case FollowupTypes.GET_FOLLOWUPS_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.followups = INITIAL_STATE.followups;
        break;

      case FollowupTypes.UPDATE_STORE_FIELDS:
        if (!state.followups) draft.followups = INITIAL_STATE.followups;
        break;

      default:
        break;
    }
  });
};

export default reducer;
